import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const moversConfirmationComponent = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/movers/confirmation')(moversConfirmationComponent);
